<template>
  <div id="app" :class="microApp ? 'micro-app-view' : ''">
    <router-view />
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    computed: {
      microApp() {
        return window.__MICRO_APP_ENVIRONMENT__ || window.top !== window
      },
    },
  }
</script>
<style lang="scss">
  .micro-app-view {
    background: #ffffff;
    .curr_position {
      margin: 0;
    }
    .asset,
    .flow-account,
    .tool-content,
    .e-account {
      padding: 20px 24px 80px 24px !important;
    }
    .jdm-title {
      color: #000 !important;
      font-size: 18px !important;
      font-weight: 500 !important;
      line-height: 26px !important;
      margin: 0 0 24px 0 !important;
      padding: 0 !important;
    }
    #assets-header {
      margin: 0 !important;
    }
  }
</style>
